import { render, staticRenderFns } from "./v-chat-bubble.vue?vue&type=template&id=80ec436c&scoped=true&"
import script from "./v-chat-bubble.vue?vue&type=script&lang=js&"
export * from "./v-chat-bubble.vue?vue&type=script&lang=js&"
import style0 from "./v-chat-bubble.vue?vue&type=style&index=0&id=80ec436c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ec436c",
  null
  
)

export default component.exports